<script>
const nav = [
  // {
  //   route: 'hyperion.biller.show',
  //   icon: 'project',
  //   text: 'Overview'
  // },
  {
    route: 'hyperion.biller.driver',
    icon: 'api',
    text: 'Drivers'
  }, {
    route: 'hyperion.biller.mutation',
    icon: 'line-chart',
    text: 'Mutations'
  }, {
    route: 'hyperion.biller.transaction',
    icon: 'barcode',
    text: 'Transactions'
  }, {
    route: 'hyperion.biller.attachment',
    icon: 'folder-open',
    text: 'Files'
  }, {
    route: 'hyperion.biller.account',
    icon: 'file-protect',
    text: 'Disbursement Account'
  }
]

export default {
  props: {
    current: {
      type: String,
      required: true
    },
    biller: {
      type: String,
      required: true
    }
  },
  data: () => ({
    nav
  })
}
</script>
<template>
  <a-menu mode="horizontal" :selected-keys="[current]">
    <a-menu-item v-for="item in nav"  :key="item.route">
      <a :href="routeUri(item.route, { biller_hash: biller })">
        <a-icon :type="item.icon"/>
        {{ item.text }}
      </a>
    </a-menu-item>
  </a-menu>
</template>
